import { getHostApis } from './getHost'
import type { BaseInstallInfoConfig } from '../../types/index'

export function getInstallInfo(): Promise<BaseInstallInfoConfig> | undefined {
  const { onelaunch } = getHostApis()
  return onelaunch?.getInstallInfo?.()
}
